import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('te_user')); } catch { return null; }
  });

  const login = (token, userData) => {
    localStorage.setItem('te_token', token);
    localStorage.setItem('te_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('te_token');
    localStorage.removeItem('te_user');
    setUser(null);
  };

  const role        = user?.role || '';
  const isAdmin     = role === 'admin';
  const isSalesMgr  = role === 'sales_manager';   // was: viewer
  const isFullViewer= role === 'fullviewer';
  const canCreate   = role === 'admin' || role === 'user';
  const canEdit     = role === 'admin' || role === 'user';
  const isViewer    = isSalesMgr || isFullViewer;  // neither can create/edit

  return (
    <AuthContext.Provider value={{
      user, login, logout,
      isAdmin, isSalesMgr, isFullViewer, isViewer,
      canCreate, canEdit
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
